// Bijhouden welke Monte Carlo-taken van deze gebruiker nog lopen, zodat de
// globale melder (McJobNotifier) ook na een pagina-wissel kan waarschuwen.
const KEY = "mc_active_jobs_v1";
const EVENT = "mc-jobs-changed";

export const ACTIVE_STATUSES = ["queued", "running"];
export const isActiveJob = (job) => !!job && ACTIVE_STATUSES.includes(job.status);

export function readActiveJobs() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* quota */ }
  window.dispatchEvent(new Event(EVENT));
}

export function trackJob({ id, scenarioId, clubId, scenarioName }) {
  const list = readActiveJobs().filter((j) => j.id !== id);
  write([...list, { id, scenarioId, clubId, scenarioName, since: Date.now() }]);
}

export function untrackJob(id) {
  write(readActiveJobs().filter((j) => j.id !== id));
}

export function onActiveJobsChange(cb) {
  window.addEventListener(EVENT, cb);
  window.addEventListener("storage", cb);
  return () => { window.removeEventListener(EVENT, cb); window.removeEventListener("storage", cb); };
}

export const scenarioPath = (j) => `/clubs/${j.clubId}/scenarios/${j.scenarioId}`;
